import script from "./TableOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableOptions.vue?vue&type=script&lang=ts&setup=true"

import "./TableOptions.vue?vue&type=style&index=0&id=5a008953&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a008953"]])

export default __exports__